import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Celebration Station",
  date: new Date(2024, 1, 11),
  img: "/img/flute-meadow.jpeg",
  video: "/videos/flute-meadow.mp4",
  tracks: [
    {
      title: "Off & Running",
      src: "/songs/2024-02-11/off_and_running.mp3",
      duration: 850.2,
    },
    {
      title: "Six On One Hand",
      src: "/songs/2024-02-11/six_on_one_hand.mp3",
      duration: 628.728,
    },
    {
      title: "Meadow's Edge",
      src: "/songs/2024-02-11/meadows_edge.mp3",
      duration: 762.624,
    },
    {
      title: "Circular Reasoning",
      src: "/songs/2024-02-11/circular_reasoning.mp3",
      duration: 842.064,
    },
    {
      title: "Sports!!!",
      src: "/songs/2024-02-11/sports.mp3",
      duration: 780.168,
    },
    {
      title: "Dancin' & Singin'",
      src: "/songs/2024-02-11/dancin_and_singin.mp3",
      duration: 673.992,
    },
    {
      title: "Do The Thing",
      src: "/songs/2024-02-11/do_the_thing.mp3",
      duration: 2244.096,
    },
    {
      title: "Toby Keith",
      src: "/songs/2024-02-11/toby_keith.mp3",
      duration: 535.248,
    },
    {
      title: "Inside Job",
      src: "/songs/2024-02-11/inside_job.mp3",
      duration: 860.136,
    },
    {
      title: "Half Ours",
      src: "/songs/2024-02-11/half_ours.mp3",
      duration: 1876.08,
    },
    {
      title: "RIP Jesus",
      src: "/songs/2024-02-11/rip_jesus.mp3",
      duration: 119.208,
    },
  ],
};
export default album;
